/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Not_FoundInputs */

const cs_share_not_found = /** @type {(inputs: Share_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz je neplatný nebo vypršel.`)
};

const en_share_not_found = /** @type {(inputs: Share_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This share link is invalid or expired.`)
};

/**
* | output |
* | --- |
* | "This share link is invalid or expired." |
*
* @param {Share_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_not_found = /** @type {((inputs?: Share_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_not_found(inputs)
	return cs_share_not_found(inputs)
});